import React from 'react';

import { Wizard } from 'components/ClubComponents';
import Dropdown from 'components/cosmos/dropdown';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import PropTypes from 'prop-types';

import {
  BY_DATE_SELECTOR,
  SELECTOR,
  CUSTOM_DAYS_SELECTOR,
  BY_DAYS_SELECTOR,
  REMOVE_DRIPPING_SELECTOR,
  PREVIOUS,
  BEGIN
} from './constants';
import CustomDaysSelector from './CustomDaysSelector';
import DateSelector from './DateSelector';
import DaysSelector from './DaysSelector';
import RemoveScheduleModal from './removeScheduleModal';
import Selector from './Selector';

import {
  clickPreviousStep,
  clickScheduleButton
} from '../DrippingBulkActionEvents';

import './Scheduler.scss';

const FLOW = {
  SELECTOR: {
    on: {
      [BY_DAYS_SELECTOR]: BY_DAYS_SELECTOR,
      [BY_DATE_SELECTOR]: BY_DATE_SELECTOR,
      [REMOVE_DRIPPING_SELECTOR]: REMOVE_DRIPPING_SELECTOR
    }
  },
  [BY_DAYS_SELECTOR]: {
    on: {
      [PREVIOUS]: SELECTOR,
      [CUSTOM_DAYS_SELECTOR]: CUSTOM_DAYS_SELECTOR
    }
  },
  [BY_DATE_SELECTOR]: {
    on: {
      [PREVIOUS]: SELECTOR,
      [BEGIN]: SELECTOR
    }
  },
  [CUSTOM_DAYS_SELECTOR]: {
    on: {
      [PREVIOUS]: BY_DAYS_SELECTOR,
      [BEGIN]: SELECTOR
    }
  },
  [REMOVE_DRIPPING_SELECTOR]: {
    on: {
      [PREVIOUS]: SELECTOR
    }
  }
};

export const CLOSING_ANIMATION_DELAY = 400;

const sendClickPreviousStepEvents = (wizardArgs) => {
  clickPreviousStep(wizardArgs);

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      label: EVENTS_LABELS.BACK,
      action: EVENTS_INTERACTIONS.CLICK
    })
  });
};

const sendClickScheduleButtonEvents = () => {
  clickScheduleButton();

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      label: EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.SCHEDULE,
      action: EVENTS_INTERACTIONS.CLICK
    })
  });
};

const SchedulerWizard = ({ button, checkedContent, onSuccess }) => {
  const wizardRef = React.useRef();
  const dropdownRef = React.useRef();
  const [openRemoveModal, setOpenRemoveModal] = React.useState(false);

  const closeMenu = () => {
    dropdownRef.current.closeMenu();
  };

  const onDropdownButtonClick = () => {
    sendClickScheduleButtonEvents();
  };

  return (
    <>
      <Dropdown
        data-test="ca-scheduler"
        className="ca-scheduler"
        ref={dropdownRef}
      >
        {React.cloneElement(button, {
          onClick: onDropdownButtonClick,
          slot: 'button'
        })}
        <Dropdown.MenuHeader className="_p-0">
          <Wizard
            id="DRIPPING_WIZARD"
            flow={FLOW}
            ref={wizardRef}
            onPreviousClick={sendClickPreviousStepEvents}
          >
            <Wizard.Step id={SELECTOR} headerless>
              {({ transition }) => (
                <Selector
                  transition={transition}
                  setOpenRemoveModal={setOpenRemoveModal}
                  toogle={closeMenu}
                />
              )}
            </Wizard.Step>

            <Wizard.Step id={BY_DAYS_SELECTOR} headerless>
              {({ transition, options }) => (
                <DaysSelector
                  type={options.type}
                  transition={transition}
                  checkedContent={checkedContent}
                  toogle={closeMenu}
                />
              )}
            </Wizard.Step>

            <Wizard.Step id={BY_DATE_SELECTOR} headerless>
              {({ transition, options }) => (
                <DateSelector
                  type={options.type}
                  checkedContent={checkedContent}
                  transition={transition}
                  toogle={closeMenu}
                />
              )}
            </Wizard.Step>

            <Wizard.Step id={CUSTOM_DAYS_SELECTOR} headerless>
              {({ transition, options }) => (
                <CustomDaysSelector
                  type={options.type}
                  transition={transition}
                  checkedContent={checkedContent}
                  toogle={closeMenu}
                />
              )}
            </Wizard.Step>
          </Wizard>
        </Dropdown.MenuHeader>
      </Dropdown>
      <RemoveScheduleModal
        open={openRemoveModal}
        onClose={() => setOpenRemoveModal(false)}
        checkedContent={checkedContent}
        onSuccess={onSuccess}
      />
    </>
  );
};

SchedulerWizard.propTypes = {
  button: PropTypes.node,
  checkedContent: PropTypes.object,
  onSuccess: PropTypes.func
};

export default SchedulerWizard;
